import React, { useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import AllCountries from "../../components/v4/AllCountries/AllCountries";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import bodySectionBg from "../../images/v4/country/usa/images/bodySectionBg.png";
import heroBg from "../../images/v4/country/usa/images/heroBg.png";

import usa from "../../images/v4/country/usa/icons/usa.svg";

import bestIcon1 from "../../images/v4/country/india/icons/bestIcon1.svg";
import bestIcon2 from "../../images/v4/country/india/icons/bestIcon2.svg";
import bestIcon3 from "../../images/v4/country/india/icons/bestIcon3.svg";
import bestIcon4 from "../../images/v4/country/india/icons/bestIcon4.svg";
import bestIcon5 from "../../images/v4/country/india/icons/bestIcon5.svg";

import smartIcon1 from "../../images/v4/country/india/icons/smartIcon1.svg";
import smartIcon2 from "../../images/v4/country/india/icons/smartIcon2.svg";
import smartIcon3 from "../../images/v4/country/india/icons/smartIcon3.svg";
import smartIcon4 from "../../images/v4/country/india/icons/smartIcon4.svg";
import smartIcon5 from "../../images/v4/country/india/icons/smartIcon5.svg";
import smartIcon6 from "../../images/v4/country/india/icons/smartIcon6.svg";
import smartIcon7 from "../../images/v4/country/india/icons/smartIcon7.svg";
import smartIcon8 from "../../images/v4/country/india/icons/smartIcon8.svg";
import smartIcon9 from "../../images/v4/country/india/icons/smartIcon9.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/country/malaysia/images/compareItemImg5.png";

import countryBackground from "../../images/v4/country/usa/images/countryBackground.png";
import benefitImg from "../../images/v4/country/usa/images/benefitImg.png";

import realWorldImg1 from "../../images/v4/country/usa/images/realWorldImg1.png";
import realWorldImg2 from "../../images/v4/country/usa/images/realWorldImg2.png";
import realWorldImg3 from "../../images/v4/country/usa/images/realWorldImg3.png";
import realWorldImg4 from "../../images/v4/country/usa/images/realWorldImg4.png";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${heroBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "100px 0 60px",
    "& .countryHighlight": {
      background: "linear-gradient(101deg, #1255A8 3.61%, #FF2B63 96.67%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
      width: "85%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
        "& .countryLogo": {
          width: "30px",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(180deg, #009A99 0%, #1C297E 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
      "& $supportBox": {
        top: "-770px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  stripSection: {
    backgroundColor: "#e9f4fe",
    // backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  testimonials: {
    background: "#e9f4fe",
  },
  wpFaq: {
    padding: "40px 0",
    background: "#eaffff",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(to right, #011d32 -1%, #00182b 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bodySectionBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "50%",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0 300px",
      "& .header": {
        width: "100%",
      },
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#ffffff1a",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "16px",
    width: "32%",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  countrySection: {
    padding: "60px 0",
    borderRadius: "40px 40px 0 0",
    backgroundImage: `url(${countryBackground})`,
    backgroundSize: "cover",
    "& .header": {
      width: "60%",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .cards": {
      display: "flex",
      width: "100%",
      justifyContent: "flex-start",
      gap: "20px",
      alignItems: "stretch",
      marginTop: "60px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        marginTop: "40px",
      },
    },
    "& .card": {
      padding: "32px 24px",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "32px",
      backdropFilter: "blur(20px)",
      border: "1px solid #534B69 ",
      width: "48%",
      background:
        "linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "0",
    },
  },
  tabsSection: {
    background: "#FFF9F0",
    paddingTop: "280px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "550px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "90%",
    minWidth: "max-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      minWidth: "100%",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "25%",
    minWidth: "max-content",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "20px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    position: "relative",
    top: "5px",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(179deg, #9E5AD5 -19.72%, #210538 105.7%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  adaptFeatures: {
    backgroundrepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${heroBg})`,
    "& .header": {
      display: "flex",
      width: "55%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .container": {
      paddingBottom: "35px",
    },
  },
  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
  },
  adaptsBox: {
    gap: "16px",
    display: "flex",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    maxWidth: "380px",
    minHeight: "220px",
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
  },
  adaptBoxHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
  },
}));

const HongKong = () => {
  const classes = useStyles();
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question:
        "What CRM software is best suited for small businesses in the United States?",
      answer: (
        <>
          Pepper Cloud CRM is designed to cater to small and mid-sized U.S.
          businesses, offering robust features such as automation, lead
          management, and custom workflows. These capabilities help teams
          enhance productivity, streamline sales processes, and drive business
          growth efficiently.
        </>
      ),
    },
    {
      question: "How can U.S. businesses begin using a CRM system?",
      answer: (
        <>
          <ul>
            <li>
              Schedule a free demo to explore Pepper Cloud CRM's features with
              our team.
            </li>
            <li>
              Collaborate with our U.S.-based experts to determine the ideal
              plan for your business needs.
            </li>
            <li>
              Set up your account easily, with no hidden fees or complex
              configurations.
            </li>
            <li>
              Tailor workflows, pipelines, and automations to align with your
              sales objectives.
            </li>
            <li>
              Start managing leads, tracking deals, and closing sales more
              effectively.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "What factors should U.S. businesses consider when selecting a CRM?",
      answer: (
        <>
          <ul>
            <li>
              Scalability to support business growth and expanding sales teams.
            </li>
            <li>
              Customisation to accommodate specific industry needs and sales
              processes.
            </li>
            <li>
              Integration with key U.S. business tools such as email,
              accounting, and marketing platforms.
            </li>
            <li>
              Access to local support to ensure smooth implementation and
              ongoing adjustments.
            </li>
            <li>
              Transparent pricing that delivers clear value and a measurable
              return on investment.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM a good fit for startups in the U.S.?",
      answer: (
        <>
          Yes, Pepper Cloud CRM is ideal for startups. It is cost-effective,
          easy to implement, and packed with automation features that help new
          businesses manage leads, optimise sales activities, and scale
          operations without unnecessary complexity.
        </>
      ),
    },
    {
      question: "Can Pepper Cloud CRM integrate with other business systems?",
      answer: (
        <>
          Yes. Pepper Cloud CRM integrates seamlessly with popular platforms
          such as Google Workspace, Outlook, QuickBooks, and various email
          marketing tools, offering a streamlined and unified business workflow.
        </>
      ),
    },
    {
      question:
        "How does Pepper Cloud CRM protect business data for U.S. companies?",
      answer: (
        <>
          Pepper Cloud CRM employs top-tier encryption, secure servers, and
          industry-leading security protocols to safeguard your business and
          customer data, all while complying with U.S. data protection
          regulations.
        </>
      ),
    },
    {
      question:
        "What are the most widely used CRM platforms in the United States?",
      answer: (
        <>
          Salesforce and HubSpot are some of the most popular platforms, but
          Pepper Cloud CRM is rapidly gaining traction among U.S. businesses for
          its affordability, advanced automation features, and dedicated support
          tailored to U.S. sales CRM needs.
        </>
      ),
    },
    {
      question:
        "Is Pepper Cloud CRM an affordable option for small and mid-sized businesses?",
      answer: (
        <>
          Yes, Pepper Cloud CRM offers a variety of flexible pricing plans,
          ensuring that small and mid-sized businesses can access high-value CRM
          tools without exceeding their budgets, allowing for scalable growth at
          an affordable cost.
        </>
      ),
    },
    {
      question:
        "What are the key characteristics of the best CRM for small businesses in the United States?",
      answer: (
        <>
          The best CRM should be user-friendly, customisable, scalable, and
          tailored to meet the specific needs of U.S. businesses. Pepper Cloud
          CRM ticks all these boxes, enabling businesses to efficiently manage
          leads, nurture customer relationships, and support long-term growth.
        </>
      ),
    },
  ];

  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Zoho CRM",
    "Microsoft Dynamics 365",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM is tailored for growing U.S. businesses, combining sales automation, omnichannel communication, and advanced tracking tools. It scales with your team and processes, making it a leading CRM for the United States.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "Workflow automation",
          desc: "Accelerate sales cycles with automated tasks, reminders, and lead progression triggers.",
        },
        {
          title: "Multichannel support",
          desc: "Communicate via email, WhatsApp, SMS, and social media from a central platform.",
        },
        {
          title: "Deal pipeline control",
          desc: "Customise pipeline stages and view progress with intuitive, real-time dashboards.",
        },
        {
          title: "Smart integrations",
          desc: "Connect with U.S. favourites like Google Workspace, Mailchimp, and QuickBooks.",
        },
        {
          title: "Built for U.S. teams",
          desc: "Offers flexible localisation, industry-ready workflows, and responsive regional support.",
        },
      ],
      cta: "Get demo",
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot is ideal for U.S. businesses seeking a strong inbound marketing CRM with user-friendly features and growth-friendly plans.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Campaign builder",
          desc: "Design and schedule personalised email marketing sequences with visual tools.",
        },
        {
          title: "Deal tracking",
          desc: "Use colour-coded pipelines to follow progress and prioritise high-value opportunities.",
        },
        {
          title: "Team collaboration",
          desc: "Share notes, assign contacts, and manage deals with integrated task management tools.",
        },
      ],
    },
    {
      title: "Salesforce",
      desc: "Salesforce supports complex enterprise needs across the U.S. with powerful automation, CRM customisation, and market-leading analytics.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "AI insights",
          desc: "Forecast sales trends and identify best actions using Salesforce’s Einstein intelligence.",
        },
        {
          title: "Advanced workflows",
          desc: "Design custom automations for high-volume teams or specialised industry needs.",
        },
        {
          title: "App integrations",
          desc: "Connect with a vast ecosystem of tools through Salesforce AppExchange for added flexibility.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM serves small and mid-size U.S. firms with affordable pricing and flexible features built for hands-on sales teams.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Cross-channel CRM",
          desc: "Centralise phone, live chat, email, and social conversations into a unified interface.",
        },
        {
          title: "AI features",
          desc: "Leverage Zia for activity suggestions, task follow-ups, and real-time lead scoring.",
        },
        {
          title: "Productivity tools",
          desc: "Gamify sales goals and track key performance indicators to drive team motivation.",
        },
      ],
    },
    {
      title: "Microsoft Dynamics 365",
      desc: "Microsoft Dynamics fits U.S. companies using Office tools, providing integrated CRM functionality, analytics, and enterprise connectivity.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "AI forecasting",
          desc: "Spot opportunities and prevent churn with predictive analytics built into your CRM views.",
        },
        {
          title: "Visual dashboards",
          desc: "Combine CRM data with Power BI for advanced reporting and custom visualisation.",
        },
        {
          title: "LinkedIn integration",
          desc: "Align lead generation with LinkedIn Sales Navigator for targeted B2B outreach.",
        },
      ],
    },
  ];

  const bestPractice = [
    {
      icon: smartIcon1,
      alt: "",
      heading: "Lead management system",
      desc: "Capture, distribute, and follow up on leads from various sources to streamline sales and ensure no opportunity is missed.",
    },
    {
      icon: smartIcon2,
      alt: "",
      heading: "AI-powered automation",
      desc: "Boost team efficiency with intelligent automation for lead nurturing, task assignment, and deal movement across the pipeline.",
    },
    {
      icon: smartIcon3,
      alt: "",
      heading: "Sales pipeline visibility",
      desc: "View and manage each deal stage visually to optimise forecasts, prioritise actions, and close deals with greater accuracy.",
    },
    {
      icon: smartIcon4,
      alt: "",
      heading: "WhatsApp CRM integration",
      desc: "Instantly connect with leads and clients through automated WhatsApp messages, improving engagement and accelerating conversions.",
    },
    {
      icon: smartIcon5,
      alt: "",
      heading: "Multichannel communication hub",
      desc: "Unify customer interactions across email, WhatsApp, and social platforms to build consistent, connected communication flows.",
    },
    {
      icon: smartIcon6,
      alt: "",
      heading: "Mobile CRM access",
      desc: "Enable remote teams to work effectively from anywhere by accessing customer data, updating deals, and tracking activities on mobile.",
    },
    {
      icon: smartIcon7,
      alt: "",
      heading: "Custom workflow builder",
      desc: "Automate your exact sales process with drag-and-drop workflows that guide leads from inquiry to conversion—hassle-free.",
    },
    {
      icon: smartIcon8,
      alt: "",
      heading: "Activity tracking tool",
      desc: "Log every interaction to maintain accountability, ensure timely follow-ups, and keep your sales cycle moving without bottlenecks.",
    },
    {
      icon: smartIcon9,
      alt: "",
      heading: "Seamless tool integrations",
      desc: "Sync your CRM with key tools like Google Workspace, QuickBooks, and Mailchimp to simplify workflows and improve visibility.",
    },
  ];
  const tabContentData = [
    {
      tabContent: [
        {
          heading: "Property alerts",
          content:
            "Send instant updates and reminders via WhatsApp, email, or SMS.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Lead filtering",
          content: "Categorize buyers by region, budget, and preferences.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Sales dashboard",
          content: "Track agent activity, sales volume, and pipeline stages.",
          alt: "Real Estate CRM",
        },
      ],
      img: realWorldImg1,
      alt: "Real Estate CRM for the U.S.",
      subtitle:
        "Real estate teams in the U.S. can streamline lead capture, manage property viewings, and speed up deal closures.",
    },
    {
      tabContent: [
        {
          heading: "Automated notifications",
          content: "Send updates, links, and feedback forms automatically.",
          alt: "Coaching and Education CRM",
        },
        {
          heading: "CRM for enquiries",
          content: "Convert leads with structured workflows and segmentation.",
          alt: "Coaching and Education CRM",
        },
        {
          heading: "Learner insights",
          content: "Track interest, participation, and feedback trends.",
          alt: "Coaching and Education CRM",
        },
      ],
      img: realWorldImg2,
      alt: "Coaching and Education CRM for the USA",
      subtitle:
        "Coaching firms and education centres can improve lead conversion, class management, and student engagement at scale.",
    },
    {
      tabContent: [
        {
          heading: "Meeting scheduling",
          content: "Automate booking, confirmations, and follow-ups.",
          alt: "Consultancy CRM",
        },
        {
          heading: "Compliance records",
          content: "Archive communications for regulations and audits.",
          alt: "Consultancy CRM",
        },
        {
          heading: "Client targeting",
          content: "Segment clients for better personalization and outreach.",
          alt: "Consultancy CRM",
        },
      ],
      img: realWorldImg3,
      alt: "Consultancy CRM for the U.S.",
      subtitle:
        "U.S.-based consultancies can improve relationship tracking, enhance trust, and maintain compliance through CRM automation.",
    },
    {
      tabContent: [
        {
          heading: "Campaign triggers",
          content: "Launch promos and discounts based on behavior.",
          alt: "Retail CRM",
        },
        {
          heading: "Purchase tracking",
          content: "Log sales data to personalize loyalty programs.",
          alt: "Retail CRM",
        },
        {
          heading: "Unified messaging",
          content: "Sync customer chats into one CRM dashboard.",
          alt: "Retail CRM",
        },
      ],
      img: realWorldImg4,
      alt: "Retail CRM for the USA",
      subtitle:
        "Online and offline retailers in the U.S. can drive loyalty, automate promotions, and manage customer interactions more effectively.",
    },
  ];
  const cards = [
    {
      heading: "What is CRM software for businesses in the United States?",
      content:
        "CRM software helps U.S. businesses organise customer data, manage sales activities, and streamline communication, improving engagement and ensuring teams work from a single, unified platform.",
    },
    {
      heading: "Why do businesses in the United States need a CRM?",
      content:
        "With increasing digital interactions and sales complexity, businesses in the United States need CRM tools to automate workflows, track performance, and build consistent, personalised customer relationships.",
    },
  ];
  const adaptList = [
    {
      pointer: "All-in-one CRM",
      desc: "Pepper Cloud brings together sales automation, lead management, and customer insights in a unified system, eliminating the need for multiple tools.",
      img: bestIcon1,
    },
    {
      pointer: "Scalable for all sizes",
      desc: "Whether you’re a lean startup or scaling enterprise, our CRM grows with you, adapting to your evolving team and sales processes.",
      img: bestIcon2,
    },
    {
      pointer: "Transparent pricing",
      desc: "Simple, value-driven plans with no hidden fees or setup costs—ideal for U.S. businesses focused on ROI and sustainable growth.",
      img: bestIcon3,
    },
    {
      pointer: "U.S. market support",
      desc: "Dedicated regional experts provide responsive, tailored support to help American teams onboard faster and sell smarter from day one.",
      img: bestIcon4,
    },
    {
      pointer: "Advanced customisation",
      desc: "Customise workflows, fields, and pipelines to match your exact sales journey and accelerate conversions through process precision.",
      img: bestIcon5,
    },
  ];
  const pointers = [
    "Centralise customer data and sales activity to improve collaboration, lead visibility, and operational efficiency company-wide.",
    "Automate daily sales workflows and lead follow-ups to increase speed, reduce errors, and drive conversions.",
    "Get instant insights from custom dashboards to improve sales strategy and boost team performance across regions.",
    "Engage leads via WhatsApp, email, and SMS in one unified platform to maximise communication effectiveness.",
  ];
  return (
    <main>
      <SEO
        title={
          "Best CRM software for U.S. businesses | Boost sales & growth with Pepper Cloud"
        }
        pathname={
          "https://peppercloud.com/country/best-crm-software-in-the-united-states/"
        }
        keywords="Best CRM Software in the United States,bunited state customer relationship management, crm for united state, sales crm United State"
        description={
          "Unlock growth with the best CRM software for U.S. businesses. Enhance sales, automate processes, and improve customer relationships with Pepper Cloud CRM. Book a demo now!"
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What CRM software is best suited for small businesses in the United States?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is designed to cater to small and mid-sized U.S. businesses, offering robust features such as automation, lead management, and custom workflows. These capabilities help teams enhance productivity, streamline sales processes, and drive business growth efficiently.",
                },
              },
              {
                "@type": "Question",
                name: "How can U.S. businesses begin using a CRM system?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "The setup process is straightforward: a. Schedule a free demo to explore Pepper Cloud CRM's features with our team. b. Collaborate with our U.S.-based experts to determine the ideal plan for your business needs. c. Set up your account easily, with no hidden fees or complex configurations. d. Tailor workflows, pipelines, and automations to align with your sales objectives. e. Start managing leads, tracking deals, and closing sales more effectively.",
                },
              },
              {
                "@type": "Question",
                name: "What factors should U.S. businesses consider when selecting a CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "a. Scalability to support business growth and expanding sales teams. b. Customisation to accommodate specific industry needs and sales processes. c. Integration with key U.S. business tools such as email, accounting, and marketing platforms. d. Access to local support to ensure smooth implementation and ongoing adjustments. e. Transparent pricing that delivers clear value and a measurable return on investment.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM a good fit for startups in the U.S.?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM is ideal for startups. It is cost-effective, easy to implement, and packed with automation features that help new businesses manage leads, optimise sales activities, and scale operations without unnecessary complexity.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud CRM integrate with other business systems?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Pepper Cloud CRM integrates seamlessly with popular platforms such as Google Workspace, Outlook, QuickBooks, and various email marketing tools, offering a streamlined and unified business workflow.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud CRM protect business data for U.S. companies?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM employs top-tier encryption, secure servers, and industry-leading security protocols to safeguard your business and customer data, all while complying with U.S. data protection regulations.",
                },
              },
              {
                "@type": "Question",
                name: "What are the most widely used CRM platforms in the United States?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Salesforce and HubSpot are some of the most popular platforms, but Pepper Cloud CRM is rapidly gaining traction among U.S. businesses for its affordability, advanced automation features, and dedicated support tailored to U.S. sales CRM needs.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM an affordable option for small and mid-sized businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM offers a variety of flexible pricing plans, ensuring that small and mid-sized businesses can access high-value CRM tools without exceeding their budgets, allowing for scalable growth at an affordable cost.",
                },
              },
              {
                "@type": "Question",
                name: "What are the key characteristics of the best CRM for small businesses in the United States?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "The best CRM should be user-friendly, customisable, scalable, and tailored to meet the specific needs of U.S. businesses. Pepper Cloud CRM ticks all these boxes, enabling businesses to efficiently manage leads, nurture customer relationships, and support long-term growth.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-72 color-black1"
            >
              Achieve B2B growth with best CRM software in the{" "}
              <img className="countryLogo" src={usa} alt="usa" />{" "}
              <span className="countryHighlight">USA</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Accelerate business growth with the best CRM software in the
              United States—built to empower B2B teams with intelligent
              automation, sales visibility, and multichannel communication that
              drive stronger customer engagement and higher conversions.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Real-time sales pipeline tracking
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Integrated multichannel engagement
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Secure, mobile-accessible CRM platform
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link
                to="/contact/"
                className="primaryButton font-20 font-wix-medium font-white"
              >
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.countrySection}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              A guide to CRM systems for US businesses
            </motion.h2>
          </div>
          <div className="cards">
            {cards.map((card) => (
              <div className="card">
                <p className="font-24 font-wix-semibold font-white">
                  {card.heading}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {card.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.adaptFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-medium font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Find out why Pepper Cloud is the go-to CRM for United States
              businesses
            </motion.h2>
          </div>
        </div>
        <Swiper
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            // 768: {
            //   slidesPerView: "auto",
            //   slidesPerGroup: 3,
            //   spaceBetween: 30,
            //   grabCursor: true,
            // },
          }}
          className={classes.adaptSlider}
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={true}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  alt={point.pointer}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold ">{point.pointer}</p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Unlock smarter sales with our powerful feature suite
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.heading} />
                <p className="font-wix-semibold font-24 font-white">
                  {practice.heading}
                </p>
                <p
                  className="font-wix-medium font-16"
                  style={{ color: "#E9F4FE" }}
                >
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          {/* <TruestedSection background={true} /> */}
        </div>
      </section>
      <section className={classes.tabsSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                Understand the key advantages of CRM tools for scaling your
                business in the United States
              </p>
              <div className={classes.pointers}>
                {pointers.map((pointer) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      className={classes.pointerImg}
                      alt={"pointer"}
                    />
                    <p className="font-inter-regular font-18 font-white">
                      {pointer}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benefitImg}
                alt={
                  "Understand the key advantages of CRM tools for scaling your business in the United States"
                }
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Exploring CRM software applications for businesses in the United
              States
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                Real estate
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Training and coaching
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Financial services
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Retail and e-commerce
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 color-black2"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.benfitListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.benfitIcon}
                              alt={item.alt}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-16 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              Exploring the top 5 CRM software solutions for businesses in the
              United States
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <TruestedSection />
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <AllCountries />
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#eaffff"}
          heading={
            "FAQS – everything you need to know about CRM software for United States businesses"
          }
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Unlock sales potential with the United States' most efficient
              lead-to-customer CRM
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default HongKong;
